import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "./home/homeSlice";
import blogSlice from "./blog/blogSlice";
import activitySlice from "./activities/activitySlice";
import attractionsSlice from "./attractions/attractionsSlice";

const store = configureStore({
  reducer: {
    home: homeSlice,
    blog: blogSlice,
    activity: activitySlice,
    attractions: attractionsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
